import {NotificationDto} from "../../repositories/dto/notification.dto";

export class NotificationsItem {

  public readonly notifications: NotificationDto[] = [];
  public readonly maxLevel: string;
  public readonly sumUnread: number;

  constructor(init?: Partial<NotificationsItem> | undefined) {
    if (init?.notifications) {
      this.notifications = init.notifications
        .sort((i1, i2) => i2.timeversion.getTime() - i1.timeversion.getTime());
    }
    this.maxLevel = this.getHighestLevel(this.notifications);
    this.sumUnread = this.notifications.filter((n) => n.isNew()).length;
  }

  public getStyling(): string | undefined {
    switch (this.maxLevel) {
      case 'WARNING':
        return this.maxLevel.toLowerCase();
    }
    return undefined;
  }

  public getSumUnread(): number {
    return this.notifications.filter((n) => n.notRead()).length;
  }

  private getHighestLevel(notifications: NotificationDto[]): string {
    const levelValues: Record<string, number> = {
      NONE: 0,
      WARNING: 1
    };

    let highestLevel = 'NONE';
    for (const obj of notifications) {
      const currentLevel = levelValues[obj.level] ?? 0;
      const highestCurrentLevel = levelValues[highestLevel] ?? 0;
      if (currentLevel > highestCurrentLevel) {
        highestLevel = obj.level;
      }
    }
    return highestLevel;
  }
}
